import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.graphite
};
export default anchor;